// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__CP9Y8","title":"ClientReferral_title__3Ss5q","itemText":"ClientReferral_itemText__2p_go"};